import filters, { Types as TypesFilters } from '@/app/shared/store/modules/Filters'
import { addNamespace } from '@/app/shared/utils/NamespaceHelper'

import longGrid, { Types as TypesLongGrid } from './LongGrid'
import wideGrid, { Types as TypesWideGrid } from './WideGrid'
import dateGranularity from './DateGranularity'

import { getInitConfig } from '@/app/sales_analysis/Services'
import Dimension from '@/app/sales_analysis/models/Dimension'

export const NAMESPACE = 'salesAnalysis/'

const _types = {
  getters: {
    DIMENSION_BY_ID: 'GETTER_DIMENSION_BY_ID',
    DIMENSIONS: 'GETTER_DIMENSIONS',
    DEFAULT_DIMENSIONS: 'GETTER_DEFAULT_DIMENSIONS',
    HAS_SELECTED_FILTERS: 'GETTER_HAS_SELECTED_FILTERS'
  },
  actions: {
    INIT_MODULE: 'INIT',
    FETCH_INIT_CONFIG: 'FETCH_INIT_CONFIG',
    APPLY_FILTERS: 'APPLY_FILTERS',
    RESET_FILTERS: 'RESET_FILTERS',
    RESET: 'RESET'
  },
  mutations: {
    ACCUMULATED_SALES_DATE_OPTION: 'ACCUMULATED_SALES_DATE_OPTION',
    SET_DIMENSIONS: 'SET_DIMENSIONS',
    SET_DEFAULT_DIMENSIONS: 'SET_DEFAULT_DIMENSIONS'
  }
}

export const Types = addNamespace(NAMESPACE, _types)

const Index = {
  namespaced: true,
  state: {
    accumulatedSalesDateOption: null,
    dimensions: null,
    defaultDimensions: null
  },
  getters: {
    [_types.getters.DIMENSION_BY_ID]: (state) => (dimensionId) => {
      return state.dimensions.find((dimension) => dimension.id === dimensionId)
    },
    [_types.getters.DIMENSIONS]: (state) => {
      return state.dimensions
    },
    [_types.getters.DEFAULT_DIMENSIONS]: (state) => {
      return state.defaultDimensions
    },
    [_types.getters.HAS_SELECTED_FILTERS]: (state, getters, rootState, rootGetters) => {
      return rootGetters[NAMESPACE + TypesFilters.getters.HAS_SELECTED_FILTERS]
    }
  },
  actions: {
    async [_types.actions.INIT_MODULE] ({ dispatch, commit }, { accumulatedSalesDateOption, defaultDimensions, dimensions }) {
      commit(_types.mutations.ACCUMULATED_SALES_DATE_OPTION, accumulatedSalesDateOption)
      commit(_types.mutations.SET_DEFAULT_DIMENSIONS, defaultDimensions)
      commit(_types.mutations.SET_DIMENSIONS, dimensions.map((dimension) => new Dimension(dimension)))
      await dispatch(_types.actions.FETCH_INIT_CONFIG)
    },
    async [_types.actions.FETCH_INIT_CONFIG] ({ dispatch, commit }) {
      const { longGrid, wideGrid } = await getInitConfig()
      dispatch(TypesLongGrid.actions.INIT, longGrid, { root: true })
      dispatch(TypesWideGrid.actions.INIT, wideGrid, { root: true })
    },
    async [_types.actions.RESET_FILTERS] ({ dispatch }) {
      dispatch(NAMESPACE + TypesFilters.actions.RESET_SELECTED_FILTERS, null, { root: true })
    },
    async [_types.actions.APPLY_FILTERS] ({ dispatch }, { storeFilters, productFilters }) {
      dispatch(NAMESPACE + TypesFilters.actions.SET_SELECTED_FILTERS, { storeFilters, productFilters }, { root: true })
    },
    async [_types.actions.RESET] ({ dispatch }) {
      dispatch(TypesLongGrid.actions.RESET, longGrid, { root: true })
      dispatch(TypesWideGrid.actions.RESET, wideGrid, { root: true })
    }
  },
  mutations: {
    [_types.mutations.ACCUMULATED_SALES_DATE_OPTION] (state, accumulatedSalesDateOption) {
      state.accumulatedSalesDateOption = accumulatedSalesDateOption
    },
    [_types.mutations.SET_DIMENSIONS] (state, dimensions) {
      state.dimensions = dimensions
    },
    [_types.mutations.SET_DEFAULT_DIMENSIONS] (state, defaultDimensions) {
      state.defaultDimensions = defaultDimensions
    }
  },
  modules: {
    longGrid,
    wideGrid,
    filters,
    dateGranularity
  }
}

export default Index



// WEBPACK FOOTER //
// ./src/app/sales_analysis/store/Index.js